(() => {
  const selector = 'button-wishlist.product-item__button-wishlist';
  const key = 'daga-wishlist-heart-state';
  const stored = () => {
    try { return new Set(JSON.parse(window.localStorage.getItem(key) || '[]')); }
    catch { return new Set(); }
  };
  const save = (items) => window.localStorage.setItem(key, JSON.stringify([...items]));
  const sync = () => {
    const items = stored();
    document.querySelectorAll(selector).forEach((button) => {
      const saved = items.has(button.dataset.productId);
      button.classList.toggle('daga-wishlist--saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest(selector);
    if (!button) return;
    const items = stored();
    const id = button.dataset.productId;
    const saved = !items.has(id);
    saved ? items.add(id) : items.delete(id);
    save(items);
    button.classList.toggle('daga-wishlist--saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }, true);
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync);
})();